import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">
                茄子视频
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              为您推荐最优质的在线视频平台，提供高清免费电影电视剧资源导航，让观影更简单、更享受。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#quick-links">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/movies" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">电影资源</Link></li>
              <li><Link to="/category/tv-series" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">电视剧资源</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">综艺节目</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">动漫动画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#recommend-platforms">推荐平台</a>
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-300 whitespace-nowrap">红桃视频</span></li>
              <li><span className="text-sm text-foreground-300 whitespace-nowrap">红杏视频</span></li>
              <li><span className="text-sm text-foreground-300 whitespace-nowrap">樱花影视</span></li>
              <li><span className="text-sm text-foreground-300 whitespace-nowrap">星辰影院</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#contact">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@qiezi.video</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>茄子视频官方</span>
              </li>
              <li>
                <Link to="/about" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap">
                  了解更多 &rarr;
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 茄子视频 Qiezi.Video - 影视平台推荐导航 | 本站仅提供平台导航推荐，不存储任何视频内容
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-background-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-200 transition-colors" rel="nofollow">免责声明</a>
            <Link to="/about" className="text-xs text-foreground-400 hover:text-background-200 transition-colors">关于我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}